<template>
  <div>
    <Account_history/>
  </div>
</template>

<script>
import Account_history from "@/components/adminArin/setting_account/Account_history";
export default {
  name: "AccountHistory",
  components: {
    Account_history
  }
}
</script>

<style scoped>

</style>
